<template>
	<div class="page error">
		<main>
			<div class="text-center">
				<Link href="/">
					<Logo />
				</Link>

				<div class="row d-flex justify-content-center">
					<div class="col-12 col-laptop-8">
						<!-- Exist: true -->
						<template v-if="texts[status]">
							<div class="heading-2xl c-violetblue-900 mt-7" v-html="texts[status].title"></div>
							<div class="text-md c-violetblue-700 mt-3" v-html="texts[status].description"></div>
						</template>

						<!-- Exist: false -->
						<template v-else>
							<div class="heading-2xl c-violetblue-900 mt-7">Er is iets misgegaan</div>
							<div class="text-md c-violetblue-700 mt-3">Onze techneuten gaan hiermee aan de slag</div>
						</template>
					</div>
				</div>

				<!-- Actions -->
				<div class="d-flex flex-column flex-laptop-row justify-content-center g-3 mt-5">
					<Button to="/">Terug naar de website</Button>
					<a href="https://www.toets-mij.nl/contact" target="_blank" class="btn btn-violetblue-lighten">Contact opnemen</a>
				</div>
			</div>
		</main>
	</div>
</template>

<script setup>
import Logo from '@components/Shared/Logo.vue';
import AuthLayout from '@layouts/AuthLayout.vue';

const props = defineProps({
	status: {
		type: Number,
		default: '',
	},
});

const texts = {
	401: {
		title: 'Toegang geweigerd',
		description: 'Je hebt geen toegang tot deze pagina',
	},
	403: {
		title: 'Toegang geweigerd',
		description: 'Je hebt geen toegang tot deze pagina',
	},
	404: {
		title: 'Pagina niet gevonden',
		description: 'Sorry, we konden de pagina die je zoekt niet vinden.',
	},
	405: {
		title: 'Pagina niet gevonden',
		description: 'Sorry, we konden de pagina die je zoekt niet vinden.',
	},
	410: {
		title: 'Pagina niet gevonden',
		description: 'Sorry, we konden de pagina die je zoekt niet vinden.',
	},
	419: {
		title: 'De pagina is verlopen',
		description: 'Keer terug naar de vorige pagina en probeer het opnieuw',
	},
	429: {
		title: 'Tijdelijk niet bereikbaar',
		description: 'Probeer het later opnieuw',
	},
	500: {
		title: 'Oeps, er ging iets mis',
		description:
			'Er wordt een automatisch bericht verzonden naar de beheerder van de site. Zie je deze fout vaker? Aarzel niet om ons een bericht te sturen via info@toets-mij.nl',
	},
	502: {
		title: 'Tijdelijk niet bereikbaar',
		description:
			'<p>Vanwege grote drukte is de website tijdelijk niet bereikbaar. Onze excuses voor het ongemak. Probeer het straks nog een keer.</p>',
	},
	503: {
		title: 'Tijdelijk niet bereikbaar',
		description:
			'<p>Vanwege grote drukte is de website tijdelijk niet bereikbaar. Onze excuses voor het ongemak. Probeer het straks nog een keer.</p>',
	},
	504: {
		title: 'Tijdelijk niet bereikbaar',
		description:
			'<p>Vanwege grote drukte is de website tijdelijk niet bereikbaar. Onze excuses voor het ongemak. Probeer het straks nog een keer.</p>',
	},
};
</script>
